import { CommonModule } from '@angular/common';
import { Component, input, Input, signal } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { getStatusColor } from '@orderna/admin-panel/src/utils/get-status-color';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [CommonModule, MatChipsModule],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
})
export class BadgeComponent {
  text = input.required<string>();
  color = input<'yellow' | 'green' | 'red' | 'gray'>();

  get badgeClasses() {
    return [
      'ord-badge',
      `ord-badge-${this.color() ?? getStatusColor(this.text().toLowerCase())}`,
    ];
  }
}
